/**
 * @file automatically generated from MApp.Spatial.Ogc.Wms.ServiceExceptionCode
 */

export enum ServiceExceptionCode {
    InvalidFormat = 0,
    InvalidCRS = 1,
    LayerNotDefined = 2,
    StyleNotDefined = 3,
    LayerNotQueryable = 4,
    InvalidPoint = 5,
    CurrentUpdateSequence = 6,
    InvalidUpdateSequence = 7,
    MissingDimensionValue = 8,
    InvalidDimensionValue = 9,
    OperationNotSupported = 10
}
